/* eslint-disable react/no-unused-prop-types */
import { string } from 'prop-types';
import { t } from '@lingui/macro';

import Filter from '../../page-framework/filter/FilterDecorator';
import { filterPropTypes } from '../../page-framework/filter/FilterPropTypes';
import OptionFilter from '../option-filter/OptionFilter';
import getOptionFilterStateServiceFactory from '../option-filter/OptionFilterStateService';

export const filterId = 'Category';
export const filterTitle = t`Category`;
export const options = [
    {
        name: t`Service Test`,
        value: 'test',
    },
    {
        name: t`Site`,
        value: 'site',
    },
    {
        name: t`Business Service`,
        value: 'businessService',
    },
    {
        name: t`Interface`,
        value: 'interface',
    },
    {
        name: t`Device`,
        value: 'device',
    },
];

function AlertCategoryFilter({ state, filterActions }) {
    return <OptionFilter options={options} state={state} filterActions={filterActions} />;
}

AlertCategoryFilter.propTypes = {
    id: filterPropTypes.id,
    title: filterPropTypes.title,
    filterActions: filterPropTypes.filterActions,
    state: string,
};

AlertCategoryFilter.defaultProps = {
    ...OptionFilter.defaultProps,
    id: filterId,
    title: filterTitle,
};

export default Filter({
    filterId,
    filterStateServiceFactory: getOptionFilterStateServiceFactory(filterTitle, options, 'category'),
})(AlertCategoryFilter);
